<script lang="ts">
    
    import Trivial from "../Components/Trivial/Trivial.svelte";
    import type { Fn } from '../global';
    import { getContext, onMount } from 'svelte';

    const playMainTheme: Fn = getContext('playMainTheme');

    onMount(playMainTheme);

</script>

<div class="view">
    <Trivial src="/trivial.json" />
</div>
